const identity = {
    "full_name": "Cloud Strife",
    "mobile_number": "020 7838 1234",
    "gender": "male",
    "national_identity_number": "123456789",
    "birth_date": "1997-01-31",
    "email_address": "cloud@avalanche.net",
    "address": "7th Heaven, Sector 7 Slums, Midgar, Eastern Continent"
}

export default identity